<div>
	<h4 style="text-align: center; margin-bottom: 15px">User Details</h4>

	<div class="DetailsGrid2Col">
		<label>Username:</label>
		<input
			[disabled]="IsLoading() == true || Processing == true"
			[(ngModel)]="Username"
			placeholder="Enter CAASS Login Name"
			class="form-control"
			type="text"
		/>

		<!--Don't Edit Passwords in 10.14. User must have valid email address and must use password reset link-->
		<!--
		<label>Password:</label>
		<input
			*ngIf="EditMode == false"
			[disabled]="IsLoading() == true || Processing == true"
			[(ngModel)]="Password"
			placeholder="Enter Password"
			class="form-control"
			type="password"
		/>
		<input
			*ngIf="EditMode == true"
			[disabled]="IsLoading() == true || Processing == true"
			[(ngModel)]="Password"
			placeholder="************"
			class="form-control"
			type="password"
		/>

		<label>Confirm Password:</label>
		<input
			*ngIf="EditMode == false"
			[disabled]="IsLoading() == true || Processing == true"
			[(ngModel)]="ConfirmPassword"
			placeholder="Retype Password"
			class="form-control"
			type="password"
		/>
		<input
			*ngIf="EditMode == true"
			[disabled]="IsLoading() == true || Processing == true"
			[(ngModel)]="ConfirmPassword"
			placeholder="************"
			class="form-control"
			type="password"
		/>

		<label class="InstructionLabel" *ngIf="LoadingInstructions == false">{{ PasswordInstructions }}</label>
		-->

		<div class="hr-line-dashed FullWidth" style="margin-bottom: 0px; margin-top: 10px"></div>

		<h5 class="FullWidth" style="text-align: center">Pick a person/staff member</h5>

		<label>School:</label>
		<p-dropdown
			(onShow)="onShow()"
			(onHide)="onHide()"
			[disabled]="IsLoading() == true || CanChangeStaff() == false || Processing == true"
			[options]="lstSchool"
			[(ngModel)]="School"
			(ngModelChange)="onSchoolChange($event)"
			optionLabel="SchoolFullName"
			[filter]="true"
			filterBy="SchoolFullName"
			[showClear]="false"
			placeholder="Select a school to pick staff from"
		>
			<ng-template pTemplate="selectedItem">
				<div *ngIf="School">
					<div class="form-control NoBorder" style="text-align: left">
						{{ School.SchoolFullName }}
					</div>
				</div>
			</ng-template>
			<ng-template let-SchoolItem pTemplate="item">
				<div>
					<div class="form-control NoBorder" style="text-align: left">
						{{ SchoolItem.SchoolFullName }}
					</div>
				</div>
			</ng-template>
		</p-dropdown>

		<label>Staff Member:</label>
		<div class="StaffSection">
			<p-dropdown
				(onShow)="onShow()"
				(onHide)="onHide()"
				[disabled]="IsLoading() == true || CanChangeStaff() == false || Processing == true"
				[options]="lstStaff"
				[(ngModel)]="Person"
				optionLabel="PersonName"
				[filter]="true"
				filterBy="PersonName"
				[showClear]="false"
				placeholder="Select a staff member"
			>
				<ng-template pTemplate="selectedItem">
					<div *ngIf="Person">
						<div class="form-control NoBorder" style="text-align: left">
							{{ Person.PersonName }}
						</div>
					</div>
				</ng-template>
				<ng-template let-PersonItem pTemplate="item">
					<div>
						<div class="form-control NoBorder" style="text-align: left">
							{{ PersonItem.PersonName }}
						</div>
					</div>
				</ng-template>
			</p-dropdown>

			<input
				id="ActiveOption"
				[disabled]="IsLoading() == true || CanChangeStaff() == false || Processing == true"
				class="form-control CheckBox"
				type="checkbox"
				(ngModelChange)="onActiveChange($event)"
				[(ngModel)]="ActiveOption"
			/>
			<label for="ActiveOption">Hide Inactive</label>
		</div>

		<div></div>
		<div *ngIf="CanChangeStaff() == true">
			<button class="btn btn-primary" [disabled]="IsLoading() == true || Processing == true" (click)="onAddStaff()">Add Staff</button>
		</div>

		<div class="hr-line-dashed FullWidth" style="margin-top: 10px; margin-bottom: 10px"></div>

		<label>User Level:</label>
		<p-dropdown
			(onShow)="onShow()"
			(onHide)="onHide()"
			[disabled]="IsLoading() == true || Processing == true"
			[options]="lstUserLevels"
			[(ngModel)]="UserLevel"
			optionLabel="UserLevelDesc"
			[filter]="true"
			filterBy="UserLevelDesc"
			[showClear]="false"
			placeholder="Select a user level"
		>
			<ng-template pTemplate="selectedItem">
				<div *ngIf="UserLevel">
					<div class="form-control NoBorder" style="text-align: left">
						{{ UserLevel.UserLevelDesc }}
					</div>
				</div>
			</ng-template>
			<ng-template let-UserLevelItem pTemplate="item">
				<div>
					<div class="form-control NoBorder" style="text-align: left">
						{{ UserLevelItem.UserLevelDesc }}
					</div>
				</div>
			</ng-template>
		</p-dropdown>
	</div>
</div>
